module.exports = __webpack_public_path__ + "img/gh-30513-5-24.prt.b3436534.jpg";